import Plyr from "plyr-react";
import React from "react";
import "plyr-react/plyr.css";
import { Box } from "@mui/material";

export default function SurveyMedia({
  url,
  type,
}: {
  url: string;
  type: string;
}) {
  if (!url || !type) return <div></div>;
  if (type.includes("image")) {
    return <img src={url} width={100} height={100} />;
  } else if (type.includes("video")) {
    return (
      <Box height={355.5} width={200}>
      <Plyr
      width="100%"
        source={{
          
          type: "video",
          sources: [
            {
              src: url,
              type: type,
            },
          ],
        }}
      />
      </Box>
    );
  } else if (type.includes("audio")) {
    return (
      <Box height={355.5} width={200}>
      <Plyr
      width="100%"
        source={{
          type: "audio",
          sources: [
            {
              src: url,
              type: type,
            },
          ],
        }}
      />
      </Box>
    );
  }

  return <div></div>;
}
